import React from 'react';
import PropTypes from 'prop-types';
import StarRating from './_StarRating';
import './_resume.scss';

const ResumeRating = ({ skill, rating }) => (
  <div key={skill} className="resume--section--block">
    <h2 className="resume--section--block-title">{skill}</h2>
    <StarRating value={rating} />
  </div>
);

ResumeRating.propTypes = {
  skill: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired,
};

export default ResumeRating;



// WEBPACK FOOTER //
// ./src/pages/resume/_Rating.js